import {
  IAreaDeliveryTimeStats,
  IAreaDeliveryTimeStatsQuery,
  IStatistics,
} from "../../models/statistcs/respons";
import { HttpClient, RequestParams } from "../../utils/api/http-client";

class StatisticsService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAllStatistics = (params?: RequestParams) =>
    this.http.request<IStatistics>({
      path: `/general-statistic`,
      method: "GET",
      ...params,
    });

  getAreaDeliveryTimeStats = (
    query?: IAreaDeliveryTimeStatsQuery,
    params?: RequestParams
  ) =>
    this.http.request<IAreaDeliveryTimeStats>({
      path: `/general-statistic/area-delivery-time`,
      method: "GET",
      query,
      ...params,
    });
}

export default StatisticsService;
